module.exports = __webpack_public_path__ + "img/038-cape-verde.58e2e974.svg";